interface InfoItem {
  label: string;
  value: string;
}

interface InfoSectionProps {
  information: InfoItem[];
  shop?: {
    location?: string;
  };
}

export default function InfoSection({
  information = [],
  shop,
}: InfoSectionProps) {
  const locationText =
    information.find((item) => item.label === '위치')?.value ||
    shop?.location ||
    '';

  const mapQuery = encodeURIComponent(locationText || '서울');

  if (information.length === 0) {
    return null;
  }

  return (
    <div id="info" className="pt-8 pb-8">
      <h2 className="text-lg font-bold text-[#121B35] mb-4">
        방문 및 예약 정보
      </h2>

      <div className="lg:grid lg:grid-cols-[1fr_1.15fr] lg:gap-4">
        <div className="bg-white rounded-2xl p-4 border border-[#E8E2DA] space-y-4">
          {information.map((item) => (
            <div key={item.label}>
              <p className="text-[11px] text-[#536079] mb-0.5">
                {item.label}
              </p>
              <p className="text-[13px] text-[#121B35]">
                {item.value || '-'}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-3 lg:mt-0 bg-white rounded-2xl border border-[#E8E2DA] overflow-hidden">
          <div className="h-[220px] lg:h-full lg:min-h-[280px]">
            <iframe
              title="지도"
              src={`https://maps.google.com/maps?q=${mapQuery}&t=&z=15&ie=UTF8&iwloc=&output=embed`}
              className="w-full h-full border-0"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>

          <div className="p-3 border-t border-[#E8E2DA] flex items-center justify-between gap-3">
            <div>
              <p className="text-[12px] font-semibold text-[#121B35]">
                {shop?.location || locationText || '위치 정보'}
              </p>
              <p className="text-[11px] text-[#536079] mt-0.5">
                방문 전 예약 가능 여부를 확인해 주세요.
              </p>
            </div>

            <a
              href={`https://www.google.com/maps/search/?api=1&query=${mapQuery}`}
              target="_blank"
              rel="noreferrer"
              className="shrink-0 text-[12px] font-medium text-[#121B35] border border-[#E8E2DA] rounded-lg px-3 py-2 whitespace-nowrap"
            >
              지도 보기
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}